export const NUTRIENT_KEYS = [
  "alcohol",
  "vitaminB7",
  "caffeine",
  "calcium",
  "carbohydrate",
  "cholesterol",
  "copper",
  "cystine",
  "energy",
  "fat",
  "fatMonounsaturated",
  "omega3ALA",
  "omega3DPA",
  "omega3EPA",
  "omega6",
  "fatPolyunsaturated",
  "fatSaturated",
  "fatTrans",
  "fiber",
  "vitaminB9",
  "histidine",
  "iron",
  "isoleucine",
  "leucine",
  "lysine",
  "magnesium",
  "manganese",
  "methionine",
  "phenylalanine",
  "phosphorus",
  "potassium",
  "protein",
  "selenium",
  "sodium",
  "starch",
  "sugar",
  "sugarAdded",
  "threonine",
  "tryptophan",
  "tyrosine",
  "valine",
  "vitaminA",
  "vitaminB1",
  "vitaminB12",
  "vitaminB2",
  "vitaminB3",
  "vitaminB5",
  "vitaminB6",
  "vitaminC",
  "vitaminD",
  "vitaminE",
  "vitaminK",
  "water",
  "zinc",
] as const;
export type NutrientKey = (typeof NUTRIENT_KEYS)[number];
